import { useMediaQuery } from '@mui/material';

/**
 * Hook to detect if the current screen is mobile device
 * Returns true if screen width is below or equal to 480px
 */
export const useIsMobile = (): boolean => {
  const isMobile = useMediaQuery('(max-width:480px)');
  return isMobile;
};
